export const navigation = [
  {
    name: 'Fleet',
    url: '/fleet',
    icon: 'fa fa-bus',
    access: ['user', 'io_admin', 'company_admin']
  },
  {
    name: 'Alert',
    url: '/alert',
    icon: 'fa fa-bell',
    access: ['user', 'io_admin', 'company_admin']
  },
  {
    name: 'Schedule Status',
    url: '/schedule',
    icon: 'fa fa-file',
    access: ['user', 'io_admin', 'company_admin']
  },
  {
    name: 'Schedule Upload',
    url: '/scheduleUpload',
    icon: 'fa fa-file',
    access: ['io_admin', 'company_admin']
  },
  {
    name: 'Application Status',
    url: '/application',
    icon: 'fa fa-bug',
    access: ['io_admin', 'company_admin']
  },
  {
    name: 'Application Upload',
    url: '/applicationUpload',
    icon: 'fa fa-bug',
    access: ['io_admin']
  },
  {
    name: 'Setting',
    url: '/setting',
    icon: 'fa fa-cog',
    access: ['io_admin', 'company_admin']
  }
];
